export const getRecordEntries = <K extends PropertyKey, V>(
    obj: Record<K, V> | Partial<Record<K, V>>,
): [K, V][] => {
    return Object.entries(obj) as [K, V][];
};
